<template>
    <div class="d-flex flex-column fill-flex">
        <fe-crud-grid
            ref="grid"
            style="height: 400px;"
            :config="$models.monitorPeriod"
            @read="v => items = v"
            domLayout="normal"
            :columnDefs="columns"
            :rowData="items"
            displayDensity="medium"
            @cellValueChanged="() => {}"
            disabledInlineCreate
            :showAddRowBtn="false"
        />

        <div class="d-flex mt-4">
            <v-text-field flat solo dense clearable v-model="name" placeholder="New period name..." style="margin-top: 7px;" class="flex-grow-1"/>

            <fe-btn :disabled="!name" @click="addPeriod">Add</fe-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PeriodBank',
        data() {
            return {
                items: [],
                name: ''
            }
        },
        computed: {
            columns() {
                return [{
                    headerName: 'Monitor',
                    field: 'name',
                    flex: 1,
                    editable: true
                }, {
                    headerName: 'Created',
                    field: 'created',
                    maxWidth: 200
                }]
            }
        },
        methods: {
            addPeriod() {
                if (!this.name) return
                let r = {
                    rank: 0,
                    name: this.name
                }

                this.$refs.grid.$refs.crud.create(r)
                    .then(() => {
                        this.$refs.grid.$refs.crud.read()
                        this.name = ''
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>